import "../../../../scss/components/_shared.scss";
import "../../../../scss/components/_tabs.scss";
import "../../../../scss/pages/implementation/_clients.scss";
import "../../../../scss/pages/patients/_patient-details.scss";

import {
  Button,
  IconLabel,
  LoadingOverlay,
} from "@finpay-development/shared-components";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import MailIcon from "@mui/icons-material/Mail";
import PersonIcon from "@mui/icons-material/Person";
import PhoneIcon from "@mui/icons-material/Phone";
import {Divider, Grid, Paper, Typography} from '@mui/material';
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  useNavigate,
  useParams,
} from "react-router-dom";

import AccessControl from "../../../../security/components/access-control";
import { RolePageNames } from "../../../../security/model/role-page-names";
import { configSettings } from "../../../../shared/configuration/config-settings";
import { RootState } from "../../../../shared/state/root-reducer";
import { AppDispatch } from "../../../../shared/state/store";
import {
  createCommentSuccesMessages,
  disabledConvertMessages, RecentlyViewedTypes,
} from '../../../../shared/enums';
import {
  phoneNumberValidator,
  emailAddressValidator,
} from "../../../../shared/misc/regex";
import {
  resetIsConverting,
  setRedirectToId,
  getInitialEncounter, clearSelectedEncounter,
} from '../../../state/patient-slice';
import {
  getInstanceOfCare,
  getPatientDemographics,
  savePatientStatus,
  setRecentlyViewedPatient, createPatientNote,
} from '../../../state/patient-thunk';
import { emptyPatientChampion } from "../../models/patient-champion";
import {
  emptyPatientEncounter,
  PatientEncounter,
} from '../../models/patient-encounter';
import { emptyPatientInsurance } from "../../models/patient-insurance";
import {
  emptyPatientViewModel,
  PatientViewModel,
} from '../../models/patient-view-model';
import { PAYMENT_TYPES } from "../../models/payment-type";
import { emptyStripePaymentMethod } from "../../models/stripe-payment-method";
import { emptyTransaction } from "../../models/transaction";
import { ChangeStatusModal } from "../../patient-overview/change-status-modal";
import { PatientModal } from "../../patient-overview/patient-modal";
import InstanceOfCare from "../instance-of-care/instance-of-care";
import Demographics from "./demographics";
import ScriptButton from "./script-button";
import { ConvertErrorHandlerModal } from "./convert-error-modal";
import { EnrollErrorHandlerModal } from "./enroll-error-modal";
import { patientService } from "../../../services/patient-service";
import {
  showErrorStatus,
  showStatus,
} from "../../../../security/state/user-slice";
import { SendToMobileQueueErrorModal } from "./send-to-mobile-queue-error-modal";
import { ClientCrm, ClientStatusCardViewModel } from "../../../../shared/model/client-status-card";
import { TakePaymentModal } from "../../../../shared/components/take-payment-modal";
import { clearPaymentURLParams } from "../../../../admissions-advisor/state/vob-slice";
import {Workflow} from '../../../../shared/model/client';
import { paynowService as paymentService } from "src/guest/services/paynow-service";
import {PrimaryAddress} from '../../../../shared/model/primary-address';
import { Payment } from "../../models/payment";
import { PatientPaymentProgram } from "../../models/patient-payment-program";
import { Utils } from 'src/shared/utils';
import { processUserRecord } from "src/shared/components/take-payment-modal/user-record-utils";
import { DetailedLedger } from "src/shared/model/ledger";
import { useSearchParams } from 'react-router-dom';

const checkAccountHolderAddress = (patientEncounter: PatientEncounter, patient: PatientViewModel)  => {

  const thirdPartyGuarantor = patientEncounter.patientChampion?.filter((champion) => champion.isGuarantor) || [];
  const accountHolderAddress: PrimaryAddress = thirdPartyGuarantor.length >0 ? thirdPartyGuarantor[0]?.contact?.primaryAddress : patient.contact?.primaryAddress;
  return !!(accountHolderAddress?.streetAddress1 && accountHolderAddress?.city && accountHolderAddress?.zipCode && accountHolderAddress?.state?.stateCode)

}

function PatientDetailsView() {
  const [tabIndex, setTabIndex] = useState(0);
  const [isCovertDisabled, setIsCovertDisabled] = useState(false);
  const [isPatientModalOpen, setIsPatientModalOpen] = useState(false);
  const [isChangeStatusModalOpen, setChangeStatusModalOpen] = useState(false);
  const [warmTransferCompletedValue, setWarmTransferCompletedValue] =
    useState(null);
  const [isMissingReqModalOpen, setIsMissingReqModalOpen] = useState(false);
  const [isEnrollModalFlow, setIsEnrollModalFlow] = useState(false);
  const [enrollRequirementsList, setEnrollRequirementsList] = useState<any>(
    []
  );
  const [
    isSendToMobileQueueErrorModalOpen,
    setIsSendToMobileQueueErrorModalOpen,
  ] = useState(false);
  const [
    sendToMobileQueueRequirementsList,
    setSendToMobileQueueRequirementsList,
  ] = useState([]);
  const [paymentData, setPaymentData] = useState<any>(undefined);
  const [isEnrollBtnVisible, setIsEnrollBtnVisible] = useState(false);
  const [isConvertingInProgress, setIsConvertingInProgress] = useState(false);

  const params = useParams<{ id?: string }>();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [openPaymentModal, setOpenPaymentModal] = useState(false);

  const [searchParams] = useSearchParams();
  const encounterId = searchParams.get('encounter');


  const selectedPatientEncounter = useSelector((state: RootState) => state.patientContext.selectedEncounter);
  const selectedPatient = useSelector((state: RootState) => state.patientContext.selectedPatient);

  // Custom function to handle both modal states
  const handleSetIsMissingReqModalOpen = (value: boolean, isEnrollFlow?: boolean) => {
    setIsMissingReqModalOpen(value);
    setIsEnrollModalFlow(!!isEnrollFlow);
  };

  useEffect(() => {

    const setEncounter = async () => {
      if(encounterId){
        dispatch(clearSelectedEncounter());
        const response = await dispatch(getInstanceOfCare({ patientId, encounterId : +encounterId })).unwrap()
        if (response.selectedPatientEncounter.workflow.workflowId === 2) {
          const type = RecentlyViewedTypes.preConvertedPatients;
          dispatch(setRecentlyViewedPatient({ patientId, encounterId: +encounterId, type }));
        } else if (response.selectedPatientEncounter.workflow.workflowId === 3){
          const type = RecentlyViewedTypes.convertedPatients;
          dispatch(setRecentlyViewedPatient({ patientId, encounterId: +encounterId, type }));
        }
        setTabIndex(1);
      }
    }

      setEncounter()

    return () => {
      setTabIndex(0);
    };
  }, [encounterId]);

  const triggerPatientModal = (isOpen: boolean) => {
    setIsPatientModalOpen(isOpen);
  };
  function handleChange(event: React.ChangeEvent<{}>, newTabIndex: number) {
    setTabIndex(newTabIndex);
    
    // When switching to Instance of Care tab
    if (newTabIndex === 1) {
      // If we have a patient but no encounter or encounter is empty, fetch initial encounter
      if (selectedPatient?.patientId && (!selectedPatientEncounter || selectedPatientEncounter === emptyPatientEncounter)) {
        // First sort and set initial encounter
        dispatch(getInitialEncounter());
        
        // Then fetch the encounter details
        if (selectedPatient.patientEncounters && selectedPatient.patientEncounters.length > 0) {
          const firstEncounter = selectedPatient.patientEncounters[0];
          dispatch(getInstanceOfCare({
            patientId: firstEncounter.patientId,
            encounterId: firstEncounter.patientEncounterId
          }));
        }
      }
    }
  }
  const handleChangeStatusModalCancel = () => {
    setChangeStatusModalOpen(false);
  };

  const handleChangeStatusModalSubmit = async (value: {
    workFlow: Workflow;
    encounterId: number;
    patientId: number;
  }) => {
    await dispatch(savePatientStatus(value));
    await setChangeStatusModalOpen(false);
    navigate(`/specialist/dashboard/${selectedPatientEncounter.patientId}`);
  };

  const isDemographicsComplete = false;
  const isIOCComplete = false;

  const selectors = {
    recentlyViewedPreConvertedPatients: useSelector(
      (state: RootState) =>
        state.patientContext.recentlyViewedPreConvertedPatients
    ),
    accountHolderContext: useSelector(
      (state: RootState) => state.patientContext.accountHolderContext
    ),
    recentlyViewedConvertedPatients: useSelector(
      (state: RootState) => state.patientContext.recentlyViewedConvertedPatients
    ),
    selectedEncounter: useSelector(
      (state: RootState) => state.patientContext.selectedEncounter
    ),
    patient: useSelector(
      (state: RootState) => state.patientContext.selectedPatient
    ),
    isLoading: useSelector(
      (state: RootState) => state.patientContext.isLoading.patientDemographics
    ),
    isLoadingIOC: useSelector(
      (state: RootState) => state.patientContext.isLoading.patientIOC
    ),
    isConverting: useSelector(
      (state: RootState) => state.patientContext.isConverting
    ),
    shouldReFetchTransactions: useSelector((state: RootState) => {
      return (
        state.patientContext?.isError?.patientTransactions ||
        state.patientContext?.selectedEncounter?.patientTransactions ===
          undefined ||
        // @ts-ignore
        (state.patientContext?.selectedEncounter?.patientTransactions === [] &&
          // @ts-ignore
          state.patientContext?.selectedEncounter?.patientTransactions ===
            [emptyTransaction])
      );
    }),
    shouldReFetchPaymentMethods: useSelector((state: RootState) => {
      return (
        state.patientContext?.isError?.paymentMethods ||
        state.patientContext?.selectedEncounter?.patientPaymentMethods ===
          undefined ||
        // @ts-ignore
        (state.patientContext?.selectedEncounter?.patientPaymentMethods ===
          [] &&
          // @ts-ignore
          state.patientContext?.selectedEncounter?.patientPaymentMethods ===
            [emptyStripePaymentMethod])
      );
    }),
    shouldReFetchDemographics: useSelector((state: RootState) => {
      return (
        !state.patientContext?.selectedPatient ||
        state.patientContext?.selectedPatient === emptyPatientViewModel
      );
    }),
    recurringPayment: useSelector((state: RootState) => {
      if (
        state.patientContext.selectedEncounter?.patientPaymentMethods?.length >
        0
      ) {
        const recurringPayment =
          state.patientContext.selectedEncounter.patientPaymentMethods.filter(
            (method) => {
              return (
                method.metadata?.metaData_paymentMethodType?.includes(
                  "RECURRING"
                ) || method?.metadata?.isRecurring
              );
            }
          );
        return recurringPayment ? recurringPayment[0] : false;
      } else {
        return false;
      }
    }),

    patientEncounters: useSelector(
      (state: RootState) =>
        state.patientContext.selectedPatient?.patientEncounters
    ),
    isDownPaymentFullyPaid: useSelector(
      (state: RootState) => state.patientContext?.isDownPaymentFullyPaid
    ),
    isLoadingTransactions: useSelector(
      (state: RootState) => state.patientContext?.isLoading?.patientTransactions
    ),
    isLoadingPaymentMethods: useSelector(
      (state: RootState) => state.patientContext?.isLoading?.paymentMethods
    ),
    allClientsMap: useSelector((state: RootState)=>state.implementationContext?.implementationSpecialistClient.allClientsWithFacilitiesMap),
    vob: useSelector(
        (state: RootState) =>
            state.admissionsAdvisorContext?.vobContext.vob
    ),
    vobPatientState: useSelector(
      (state: RootState) =>
          state.admissionsAdvisorContext?.vobPatientContext.patient
    ),
    estimatorState: useSelector(
      (state: RootState) =>
          state.admissionsAdvisorContext.estimatorContext.estimate
    ),
    patientPaymentProgram: useSelector((state: RootState) => {
      return state?.patientContext?.selectedEncounter?.patientPaymentProgram?.length > 0 ?
      state.patientContext.selectedEncounter.patientPaymentProgram[state.patientContext.selectedEncounter.patientPaymentProgram.length - 1] : {} as PatientPaymentProgram
    }),
    userRoleId: useSelector((state: RootState) => state.userContext.userProfile.userRole.userRoleId),
    transactions: useSelector((state: RootState) => state.patientContext.selectedEncounter?.patientTransactions?.length > 0 
                                                      && state.patientContext.selectedEncounter.patientTransactions),
    userProfile: useSelector((state: RootState) => {
      return state.userContext.userProfile;
    }),
  };
  const {
    patient,
    selectedEncounter,
    isLoading,
    isLoadingIOC,
    recurringPayment,
    patientEncounters,
    isDownPaymentFullyPaid,
    isLoadingTransactions,
    isLoadingPaymentMethods,
    shouldReFetchDemographics,
    shouldReFetchTransactions,
    shouldReFetchPaymentMethods,
    isConverting,
    allClientsMap,
    vob,
    vobPatientState,
    estimatorState,
    patientPaymentProgram,
    transactions,
    userRoleId,
    userProfile
  } = selectors;

  const patientId = parseInt(params.id || "") || 0;

  const clientItem: ClientStatusCardViewModel = allClientsMap!.get(selectedEncounter?.clientId)!;
  const clientCrm: ClientCrm[] | undefined = clientItem?.clientCrm!;
  const isIntegrationEnabled = clientCrm?.some((crm: ClientCrm) => crm.isIntEnabled);

  // Use centralized downpayments calculation from Redux state
  const downPayments = selectedEncounter?.encounterLedger?.downpayments || [];
  const downPaymentsSum = selectedEncounter?.encounterLedger?.downpaymentsSum || 0;

  useEffect(() => {
    if (shouldReFetchDemographics) {  
      dispatch(getPatientDemographics(patientId));
    }
  }, [dispatch, patientId, shouldReFetchDemographics]);

  useEffect(() => {
    if (vob?.urlParams?.op === 'pay') {
      setPaymentData({
        patientId: vobPatientState?.fpPatientId,
        patientEncounterId: estimatorState?.patientEncounterId,
        paymentType: PAYMENT_TYPES.DOWN_PAYMENT,
        paymentChannelId: userProfile.userRole.roleType === 'I' ? 5 : 3
      });
      setOpenPaymentModal(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

  function handlePaymentModalCancel() {
    setOpenPaymentModal(false);
    dispatch(clearPaymentURLParams());
  }

  function handleModalSubmit() {
    setIsPatientModalOpen(false);
  }

  function handleModalCancel() {
    setIsPatientModalOpen(false);
  }

  function handleEnrollModalCancel() {
    setIsMissingReqModalOpen(false);
    setIsEnrollModalFlow(false);
  }

  function handleSendToMobileModalCancel() {
    setIsSendToMobileQueueErrorModalOpen(false);
  }

  const doesSelectedEncounterExist =
    selectedEncounter !== emptyPatientEncounter;

  const doesInsuranceExist =
      doesSelectedEncounterExist &&
      selectedEncounter?.patientInsurance?.length > 0 &&
      selectedEncounter?.patientInsurance[0] !== emptyPatientInsurance;

  const doesChampionExist =
      (doesSelectedEncounterExist &&
          selectedEncounter?.patientChampion?.length > 0 &&
          selectedEncounter?.patientChampion[0] !== emptyPatientChampion) ||
      selectedEncounter?.hasChampions === false; // if we have champions, or hasChampions is explicitly false

  const doesPaymentProgramExist =
      doesSelectedEncounterExist &&
      selectedEncounter?.patientPaymentProgram?.length > 0 &&
      selectedEncounter?.patientPaymentProgram[
          selectedEncounter.patientPaymentProgram.length - 1
      ]?.downPmtAmt >= 0;

  const doesPaymentProgramPFRMatchEncounterPFR =
      doesPaymentProgramExist &&
      selectedEncounter.patientPaymentProgram[selectedEncounter.patientPaymentProgram.length - 1]
      .patientPaymentSchedule.pfrAmt === selectedEncounter.pfrAmt

  const isFullPayPlan =
      doesPaymentProgramExist &&
      selectedEncounter?.patientPaymentProgram[
          selectedEncounter.patientPaymentProgram.length - 1
      ]?.patientPaymentSchedule?.paymentFreq === 'F';

  const doesDownPaymentExist =
      doesSelectedEncounterExist &&
      doesPaymentProgramExist &&
      downPayments &&
      downPayments?.length > 0;

  const doesRecurringPaymentExist =
      !!(
          doesSelectedEncounterExist &&
          doesPaymentProgramExist &&
          recurringPayment
      ) ||
      (doesSelectedEncounterExist && doesPaymentProgramExist && isFullPayPlan);

  const isPatientEnrolled =
      selectedEncounter?.workflow?.workflowId === 3

  const doesRiskClassExist = selectedEncounter?.riskClass?.riskClassId;

  const doesMatchIOCConditions =
      doesSelectedEncounterExist &&
      selectedEncounter?.patientId > 0 &&
      selectedEncounter?.facilityId !== -1 &&
      selectedEncounter?.facilityId !== null &&
      selectedEncounter?.clientId !== -1 &&
      selectedEncounter?.clientId !== null &&
      selectedEncounter?.payorRisk?.payorRiskId > 0 &&
      selectedEncounter?.timingRisk?.timingRiskId > 0 &&
      selectedEncounter?.pfrAmt > 0 &&
      selectedEncounter?.workflow?.workflowId > 0;

  const doesMatchDemoConditions =
      patient?.contact?.firstName !== '' &&
      patient?.contact?.firstName !== null &&
      patient?.contact?.lastName !== '' &&
      patient?.contact?.lastName !== null &&
      patient?.contact?.email !== '' &&
      patient?.contact?.email !== null &&
      emailAddressValidator.test(patient?.contact?.email) &&
      patient?.contact?.primPhoneNum !== '' &&
      patient?.contact?.primPhoneNum !== null &&
      phoneNumberValidator.test(patient?.contact?.primPhoneNum);

  const isAccountHolderAddressComplete = checkAccountHolderAddress(selectedEncounter, patient);

  const isZeroDown = selectedEncounter?.patientPaymentProgram?.length > 0 && selectedEncounter?.patientPaymentProgram?.[selectedEncounter?.patientPaymentProgram.length - 1].downPmtAmt === 0;

  const isZeroDownZeroRecurring = isZeroDown
    && selectedEncounter?.patientPaymentProgram?.[selectedEncounter?.patientPaymentProgram.length - 1].patientPaymentSchedule.terms === 0 
    && selectedEncounter?.patientPaymentProgram?.[selectedEncounter?.patientPaymentProgram.length - 1].patientPaymentSchedule.paymentDueAmt === 0
    && selectedEncounter?.patientPaymentProgram?.[selectedEncounter?.patientPaymentProgram.length - 1].patientPaymentSchedule.paymentFreq !== 'F';

  const handleDisableConvert = () => {
      setWarmTransferCompletedValue(null);
  };

  useEffect(() => {
      const disabledRequirementList = [
          {
            requirementName: disabledConvertMessages.accountHolderAddress,
              status: isAccountHolderAddressComplete
          },
          {
              requirementName: disabledConvertMessages.iocLoadingLabel,
              requirementNameInfo: disabledConvertMessages.iocLoadingTooltip,
              status: !isLoading || !isLoadingIOC,
          },
          {
              requirementName: disabledConvertMessages.championLabel,
              status: doesChampionExist,
          },
          {
              requirementName: disabledConvertMessages.paymentProgramLabel,
              status: doesPaymentProgramExist,
          },
          {
              requirementName: disabledConvertMessages.downPaymentLabel,
              status: isZeroDown || isDownPaymentFullyPaid,
          },
          {
              requirementName: disabledConvertMessages.recurringPaymentLabel,
              status: doesRecurringPaymentExist,
          },
          {
              requirementName: disabledConvertMessages.zeroRecurringPaymentLabel,
              status: !isZeroDownZeroRecurring,
          },
          {
              requirementName: disabledConvertMessages.iocCompletedLabel,
              status: doesMatchIOCConditions,
          },
          {
              requirementName: disabledConvertMessages.demographicsLabel,
              status: doesMatchDemoConditions,
          },
          {
              requirementName: disabledConvertMessages.riskClassLabel,
              status: doesRiskClassExist,
          },
          {
            requirementName: disabledConvertMessages.pfrMissmatchLable, 
            status:  doesPaymentProgramPFRMatchEncounterPFR
          }
      ];
      setEnrollRequirementsList(disabledRequirementList);

      const disableConvertConditions = () => {
          return (
              !(
                  (!isLoading || !isLoadingIOC) &&
                  doesChampionExist &&
                  doesPaymentProgramExist &&
                  (isZeroDown || (isDownPaymentFullyPaid && doesDownPaymentExist)) &&
                  !isZeroDownZeroRecurring &&
                  doesRecurringPaymentExist &&
                  doesMatchIOCConditions &&
                  doesMatchDemoConditions &&
                  isAccountHolderAddressComplete &&
                  tabIndex === 1 
              ) ||
              isConverting ||
              !doesRiskClassExist 
          );
      };
      setIsCovertDisabled(disableConvertConditions());

      const client = allClientsMap?.get(selectedEncounter?.clientId);
      setIsEnrollBtnVisible(client?.paymentProgramVersion === 4);

      // eslint-disable-next-line
  }, [
      isLoading,
      isLoadingIOC,
      tabIndex,
      isConverting,
      doesRiskClassExist,
      doesChampionExist,
      isDownPaymentFullyPaid,
      doesPaymentProgramExist,
      doesDownPaymentExist,
      doesRecurringPaymentExist,
      doesMatchIOCConditions,
      doesMatchDemoConditions,
      warmTransferCompletedValue,
      allClientsMap,
      selectedEncounter,
  ]);

  const processError = (response: any) => {
    if (response.entity?.code) dispatch(showErrorStatus(response.entity?.message || response.entity));
    else dispatch(showErrorStatus(response.entity || response.errorMessage));
  }
  const patientInfoHeader = (
      <>
          <Grid
              item
              container
              xs={12}
              justifyContent="flex-start"
              alignItems="flex-start"
          >
              <Grid item className="pr-4">
                  <IconLabel
                      icon={<PersonIcon />}
                      label={`${patient?.contact?.firstName} ${patient?.contact?.lastName}`}
                      isBold={true}
                  />
              </Grid>
              <Grid item className="pr-4">
                  <IconLabel
                      icon={<MailIcon />}
                      label={`${patient?.contact?.email}`}
                      isBold={true}
                  />
              </Grid>
              <Grid item className="pr-4">
                  <IconLabel
                      icon={<PhoneIcon />}
                      label={`${patient?.contact?.primPhoneNum}`}
                      isBold={true}
                  />
              </Grid>
          </Grid>
          <Divider />
      </>
  );

  const tabs = (
      <Grid item xs={12} className="tabs">
          <Tabs
              TabIndicatorProps={{
                  style: {
                      display: 'none',
                  },
              }}
              value={tabIndex}
              onChange={handleChange}
          >
              <Tab
                  className="py-3"
                  disableRipple
                  icon={
                      isDemographicsComplete ? <CheckCircleOutlineIcon /> : ''
                  }
                  label="Demographics"
                  test-id="demographics-tab"
              />
              <Tab
                  disableRipple
                  icon={isIOCComplete ? <CheckCircleOutlineIcon /> : ''}
                  label="Instance Of Care"
                  test-id="instance-of-care-tab"
              />
          </Tabs>
      </Grid>
  );

  async function handleConvert() {
    try {
      // First check if all requirements are met
      const unfulfilled = enrollRequirementsList.filter((req: any) => !req.status);
      if (unfulfilled.length > 0) {
        // If there are unfulfilled requirements, show the modal and return
        handleSetIsMissingReqModalOpen(true, false);
        return;
      }
      
      // Disable the button and show spinner at the start
      setIsConvertingInProgress(true);

      // Call the shared function for conversion flow
      await Utils.enroll({
        selectedEncounter,
        paymentProgram: patientPaymentProgram,
        downPayments: downPayments,
        isCovertDisabled: false,
        isZeroDownZeroRecurring,
        setIsMissingReqModalOpen: handleSetIsMissingReqModalOpen,
        setIsEnrollLoading: (loading: boolean) => {
          dispatch(resetIsConverting());
        },
        dispatch,
        userName: userProfile.userName,
        computedDownPaymentsSum: downPaymentsSum,
        client: clientItem,
        isIntegrationEnabled,
        isEnrollFlow: false,
        selectedPatient: patient,
        isZeroDown,
        clientCrm,
        processError,
        processUserRecord,
        mapToDownPayment
      });
      
      // Re-enable the button when done
      setIsConvertingInProgress(false);
    } catch (error) {
        console.error('Conversion failed:', error);
        dispatch(showErrorStatus((error as Error).message));
      // Re-enable the button on error
      setIsConvertingInProgress(false);
    }
  }

  const handleStatusChange = () => {
      if (selectors.patient.patientEncounters) {
          setChangeStatusModalOpen(true);
      }
  };

  const mapToDownPayment = () => {
    const currentDateTime = new Date();
    const tempEmailAddress = "junk@finpay.com";
    const paymentChannelId = 5
    
    return {
      paymentId: 0,
      isManual: true, 
      isAuthExpired: false,
      paymentGroupId: `${patientPaymentProgram?.patientPaymentSchedule?.patientPaymentScheduleId}`,
      patientPaymentScheduleId: patientPaymentProgram?.patientPaymentSchedule?.patientPaymentScheduleId,
      patientId: selectedEncounter.patientId,
      patientEncounterId: selectedEncounter.patientEncounterId,
      paymentAmt: 0,
      paymentType: PAYMENT_TYPES.DOWN_PAYMENT,
      paymentInitDt: currentDateTime.toISOString(),
      isAuthOnly: true,
      receiptEmail: tempEmailAddress,
      paymentChannelId: paymentChannelId
    } as Payment;
  }

  const handleSendToMobile = async () => {

      const response = await patientService.sendInstanceOfCareToMobile(
        selectedEncounter.patientEncounterId
      );

      if(!response.hasErrors){

        dispatch(createPatientNote({
          message: createCommentSuccesMessages.comment,
          comment: {
            patientId: selectedEncounter.patientId,
            patientEncounterId: selectedEncounter.patientEncounterId,
            noteText: "Mobile engagement sent successfully",
            noteDt: new Date().toISOString(),
            completionDueDt: "",
            patientNotesId: 0,
          },
          showNotify: false
        }))
        setSendToMobileQueueRequirementsList([]);
        dispatch(showStatus("IOC Sent to Mobile"));
        await dispatch(setRedirectToId(0));
        navigate(`/specialist/dashboard`);

      }else{

        let noteText: string;

        if(Array.isArray(response.entity?.failureMessages) && response.entity?.failureMessages.length > 0){

          noteText = `Mobile engagement failed : ${response.entity?.failureMessages.join("; ")}`

          //modal with failed requirements
          setSendToMobileQueueRequirementsList(response.entity?.failureMessages);
          setIsSendToMobileQueueErrorModalOpen(true);

        }else{

          if(response.statusCode && response.statusCode >= 400 && response.statusCode < 500){

            noteText = `Mobile engagement failed : ${response.entity.message}`
            dispatch(showErrorStatus(response.entity.message));

          }else{
            noteText = `Mobile engagement failed`
            dispatch(showErrorStatus("Something went wrong while sending mobile engagement. Please reach out to the tech team for support."))
          }
        }

        dispatch(createPatientNote({
          message: createCommentSuccesMessages.comment,
          comment: {
            patientId: selectedEncounter.patientId,
            patientEncounterId: selectedEncounter.patientEncounterId,
            noteText,
            noteDt: new Date().toISOString(),
            completionDueDt: "",
            patientNotesId: 0,
          },
          showNotify: false
        }))

      }

  }

  const mobilePaymentWorkflowSubStatusIds = [60, 61, 62, 63, 64, 65];
  const displaySendToMobileButton =
      !selectedEncounter?.isConverted &&
      !mobilePaymentWorkflowSubStatusIds.includes(
          +selectedEncounter?.workflow?.workflowSubStatus?.workflowSubStatusId
      );

  const footerButtons = (
      <Paper
          sx={{position: 'fixed', bottom: 0, left: 0, right: 0}}
          elevation={3}
      >
          <Grid
              container
              justifyContent="center"
              alignItems="center"
              className="py-4"
          >
              <Grid item>
                  {displaySendToMobileButton && (
                      <AccessControl
                          rolePageName={RolePageNames.PatientRecords}
                          actionName="Add Instance of Care"
                          renderNoAccess={() => (
                              <Button
                                  type="secondary"
                                  marginRight={6}
                                  disabled
                              >
                                  Send to Mobile
                              </Button>
                          )}
                      >
                          <Button
                              type="secondary"
                              marginRight={6}
                              disabled={
                                  isLoading || isLoadingIOC || tabIndex === 0 || isConvertingInProgress
                              }
                              onClick={() => handleSendToMobile()}
                              test-id="send-to-mobile-btn"
                          >
                              Send to Mobile
                          </Button>
                      </AccessControl>
                  )}
                  <AccessControl
                      rolePageName={RolePageNames.PatientRecords}
                      actionName="Change Status"
                      renderNoAccess={() => (
                          <Button disabled marginRight={6}>
                              Change Status
                          </Button>
                      )}
                  >
                      <Button
                          onClick={() => handleStatusChange()}
                          type="secondary"
                          disabled={isLoading || isLoadingIOC || tabIndex === 0 || isConvertingInProgress}
                          marginRight={6}
                          test-id="footer-change-status-button"
                      >
                          Change Status
                      </Button>
                  </AccessControl>
                  <ScriptButton
                      selectedEncounter={selectedEncounter}
                      disable={isLoading || isLoadingIOC || tabIndex === 0 || isConvertingInProgress}
                      environment={configSettings.app_environment}
                  />
                  {!selectedEncounter?.isConverted && !isEnrollBtnVisible && (
                      <AccessControl
                          rolePageName={RolePageNames.PatientRecords}
                          actionName="Convert Account"
                          renderNoAccess={() => (
                              <Button disabled>Convert</Button>
                          )}
                      >
                          <Button
                              loading={isConvertingInProgress}
                              disabled={isConvertingInProgress || tabIndex === 0}
                              onClick={() => handleConvert()}
                              spinnerLeftPosition={5}
                              test-id="convert-button"
                          >
                              Convert
                          </Button>
                      </AccessControl>
                  )}
              </Grid>
          </Grid>
          {isChangeStatusModalOpen && (
              <ChangeStatusModal
                  open={isChangeStatusModalOpen}
                  handleModalCancel={handleChangeStatusModalCancel}
                  handleModalSubmit={handleChangeStatusModalSubmit}
              />
          )}
      </Paper>
  );

  return (
      <div>
          <main className="patient-details">
              <div className="content extra-padding">
                  {!isLoading ? (
                      <>
                          <Grid container spacing={2}>
                              {patientInfoHeader}
                              {tabs}
                              {tabIndex === 0 && (
                                  <>
                                      <Grid item xs={12}>
                                          <div
                                              style={{
                                                  display: patient?.patientId
                                                      ? 'none'
                                                      : '',
                                              }}
                                          >
                                              <Typography
                                                  component="h1"
                                                  variant="h2"
                                                  align="center"
                                                  color="text.primary"
                                                  gutterBottom
                                              >
                                                  Sorry, you don't have access
                                                  to the 'Demographics' tab.{' '}
                                                  <br />
                                                  Please continue to the
                                                  'Instance of Care' tab. <br />
                                                  If you believe this is an
                                                  error, please reach out to a
                                                  FinPay administrator.
                                              </Typography>
                                          </div>
                                          <div
                                              style={{
                                                  visibility: patient?.patientId
                                                      ? undefined
                                                      : 'hidden',
                                              }}
                                          >
                                              {/* If the get patient data boundary check fails, we want to hide the demographics tab
                        but still want to render the component so all the logic within it runs and prevents things from breaking*/}
                                              <Demographics
                                                  currentPatient={patient}
                                                  openPatientModal={
                                                      triggerPatientModal
                                                  }
                                              />
                                          </div>
                                      </Grid>
                                  </>
                              )}
                              <Grid item xs={12}>
                                  {tabIndex === 1 && (
                                      <InstanceOfCare
                                          doesSelectedPatientEncounterExist={doesSelectedEncounterExist}
                                          doesInsuranceExist={doesInsuranceExist}
                                          doesChampionExist={doesChampionExist}
                                          doesPaymentProgramExist={doesPaymentProgramExist}
                                          shouldReFetchTransactions={shouldReFetchTransactions}
                                          shouldReFetchPaymentMethods={shouldReFetchPaymentMethods}
                                          doesDownPaymentExist={doesDownPaymentExist}
                                          doesRecurringPaymentExist={doesRecurringPaymentExist}
                                          isPatientEnrolled={isPatientEnrolled}
                                          isLoadingTransactions={isLoadingTransactions}
                                          isLoadingPaymentMethods={isLoadingPaymentMethods}
                                          handleDisableConvert={handleDisableConvert}
                                          isCovertDisabled={isCovertDisabled}
                                          setIsMissingReqModalOpen={handleSetIsMissingReqModalOpen}
                                      />
                                  )}
                              </Grid>
                          </Grid>
                          <PatientModal
                              open={isPatientModalOpen}
                              isEdit={true}
                              handleModalCancel={handleModalCancel}
                              handleModalSubmit={handleModalSubmit}
                          />
                      </>
                  ) : (
                      <LoadingOverlay />
                  )}
              </div>
          </main>
          {patientEncounters && footerButtons}
          {isEnrollModalFlow ? (
            <EnrollErrorHandlerModal
              selectedPatientTab={tabIndex}
              handleModalCancel={handleEnrollModalCancel}
              isOpen={isMissingReqModalOpen}
              requirementList={enrollRequirementsList}
              isLoadingStatus={isLoading || isLoadingIOC}
            />
          ) : (
            <ConvertErrorHandlerModal
              selectedPatientTab={tabIndex}
              handleModalCancel={handleEnrollModalCancel}
              isOpen={isMissingReqModalOpen}
              requirementList={enrollRequirementsList}
              isLoadingStatus={isLoading || isLoadingIOC}
            />
          )}
          <SendToMobileQueueErrorModal
              isOpen={isSendToMobileQueueErrorModalOpen}
              handleModalCancel={handleSendToMobileModalCancel}
              requirementList={sendToMobileQueueRequirementsList}
          />
          {openPaymentModal
            && <TakePaymentModal paymentData={paymentData} open={openPaymentModal} handleModalCancel={handlePaymentModalCancel} />
          }
      </div>
  );
}
export default PatientDetailsView;
